import React, { useMemo } from 'react';
import { Card } from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

// Random color generator
const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8', '#82CA9D', '#FFC658', '#FF6B6B', '#6B66FF'];

function CustomerDistribution({ productions }) {
    // Process data for customer distribution
    const chartData = useMemo(() => {
        const customerCounts = {};

        // Count productions by customer
        productions.forEach((production) => {
            const customerName = production.aaroCustomerName || 'Bilinmeyen';
            if (!customerCounts[customerName]) {
                customerCounts[customerName] = 0;
            }
            customerCounts[customerName]++;
        });

        // Convert to array and sort
        const data = Object.entries(customerCounts)
            .map(([name, value]) => ({ name, value }))
            .sort((a, b) => b.value - a.value); // Sort by count (descending)

        // Limit to top 5 + "Others"
        let processedData;
        if (data.length > 5) {
            const top5 = data.slice(0, 5);
            const others = {
                name: 'Diğer',
                value: data.slice(5).reduce((sum, item) => sum + item.value, 0),
            };
            processedData = [...top5, others];
        } else {
            processedData = data;
        }

        return processedData.map((item, index) => ({
            id: index,
            value: item.value,
            label: item.name,
            color: COLORS[index % COLORS.length],
        }));
    }, [productions]);

    const totalProductions = productions.length;

    return (
        <Card>
            <MDBox p={3}>
                <MDBox mb={2} display="flex" justifyContent="space-between">
                    <MDTypography variant="h5" fontWeight="medium">
                        Müşteri Dağılımı
                    </MDTypography>
                </MDBox>
                <MDBox height="15.625rem">
                    <PieChart
                        series={[
                            {
                                data: chartData,
                                highlightScope: { faded: 'global', highlighted: 'item' },
                                faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
                            },
                        ]}
                        height={250}
                        width="100%"
                        slotProps={{
                            legend: {
                                position: { vertical: 'bottom', horizontal: 'middle' },
                                itemMarkWidth: 10,
                                itemMarkHeight: 10,
                                markGap: 5,
                                itemGap: 10,
                            },
                        }}
                        tooltip={{
                            trigger: 'item',
                            formatter: (params) => {
                                const percentage = Math.round((params.value / totalProductions) * 100);
                                return `${params.label}: ${params.value} üretim (${percentage}%)`;
                            },
                        }}
                    />
                </MDBox>
                <MDBox pt={2} display="flex" justifyContent="center">
                    <MDTypography variant="body2" color="text">
                        {`Toplam ${totalProductions} üretim`}
                    </MDTypography>
                </MDBox>
            </MDBox>
        </Card>
    );
}

export default CustomerDistribution;
